import { render, staticRenderFns } from "./StorageSpacesComponent.vue?vue&type=template&id=27a35d2e&"
import script from "./StorageSpacesComponent.vue?vue&type=script&lang=js&"
export * from "./StorageSpacesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports